import styled from 'styled-components';

import { Colors } from 'components/utils/styles/ui';
import { Button as ButtonBase } from 'components/elements/button';
import {
  Fieldset as FieldsetBase,
  Submit as SubmitBase,
} from 'components/structure/form/styles/form';

export const Wrapper = styled.div`
  padding: 2rem 4rem;
  padding-top: 0.5rem;
  width: 60rem;
  border-radius: 0.6rem;
  background-color: white;
  color: ${Colors.text};
`;

export const Header = styled.h4`
  font-size: 2rem;
  font-weight: 500;
  color: ${Colors.tealDark};
  margin-bottom: 2rem;
`;

export const Title = styled.h2`
  font-size: 2.4rem;
  margin-bottom: 1rem;
  color: ${Colors.text};
`;

export const Form = styled.form`
  margin: 0;
  display: flex;
  flex-direction: column;
`;

export const Fieldset = styled(FieldsetBase)`
  width: 100%;
  margin-bottom: 2rem;
`;

export const Submit = styled(SubmitBase)`
  align-self: flex-end;
  margin-left: auto;
`;

export const ButtonCancel = styled(ButtonBase)`
  align-self: flex-start;
  border-color: ${Colors.grey};
  height: 4rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin: 2rem 0 1rem 0;
  padding-top: 2rem;
  gap: 1rem;
  border-top: 1px solid ${Colors.outline};
`;

export const Description = styled.p`
  font-size: 1.4rem;
  color: ${Colors.text};
  margin: 0 0 2rem 0;
  line-height: 1.5;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin: 2rem 0 0 0;
  padding-top: 2rem;
  border-top: 1px solid ${Colors.outline};
`;

export const ToggleLink = styled.button`
  background: none;
  border: none;
  color: ${Colors.teal};
  text-decoration: underline;
  cursor: pointer;
  font-size: 1.4rem;
  padding: 0;
  margin: 1.5rem 1rem 0 1rem;

  &:hover {
    color: ${Colors.tealDark};
  }
`;

export const WarningBox = styled.div<{ noMargin?: boolean }>`
  padding: 1.2rem;
  margin: ${(props) => (props.noMargin ? '0' : '0 0 1.5rem 0')};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  line-height: 1.8rem;
  background-color: ${Colors.yellowLighter};
  border: 1px solid ${Colors.yellow};
  border-radius: 0.4rem;
  color: ${Colors.text};
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 2rem 0 0 0;

  label {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${Colors.text};
    cursor: pointer;
  }
`;

export const FormWrapper = styled.div`
  background: ${Colors.white};
  border-radius: 0.8rem;
  padding: 3rem;
  box-shadow: 0 0.2rem 0.4rem ${Colors.blackMoreTransparent};
  max-width: 40rem;
  width: 100%;
  margin: 0 auto;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0 0 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 20rem;
`;
